// Общие современные стили для админки

/** Компактные кнопки шапок списков / тулбаров (как в Timetable). */
export const ADMIN_COMPACT_BUTTON = {
  minHeight: 30,
  padding: '3px 10px',
  fontSize: '0.75rem',
  fontWeight: 600,
  textTransform: 'none',
  borderRadius: 6,
  boxShadow: 'none',
  whiteSpace: 'nowrap',
  lineHeight: 1.25,
  '&:hover': {
    boxShadow: 'none',
  },
  '&:disabled': {
    opacity: 0.6,
  },
  '& .MuiButton-label': {
    whiteSpace: 'nowrap',
  },
};

export const ADMIN_HEADER_ACTIONS = {
  display: 'flex',
  flexWrap: 'nowrap',
  alignItems: 'center',
  flexShrink: 0,
  '& > * + *': {
    marginLeft: 6,
  },
};

export const adminStyles = theme => ({
  container: {
    padding: theme.spacing(4),
    maxWidth: 1400,
    margin: '0 auto',
    backgroundColor: '#f5f5f5',
    minHeight: 'calc(100vh - 64px)',
  },
  paper: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    borderRadius: 12,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    backgroundColor: '#ffffff',
    overflowX: 'auto',
    maxWidth: '100%',
    transition: 'box-shadow 0.3s ease',
    '&:hover': {
      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    },
  },
  table: {
    minWidth: 650,
    '& thead th': {
      backgroundColor: '#f8f9fa',
      fontWeight: 600,
      fontSize: '0.875rem',
      color: '#495057',
      borderBottom: '2px solid #dee2e6',
    },
    '& tbody tr': {
      transition: 'background-color 0.2s ease',
      '&:hover': {
        backgroundColor: '#f8f9fa',
      },
    },
    '& tbody td': {
      borderBottom: '1px solid #e9ecef',
      padding: theme.spacing(1.5),
    },
  },
  filterSection: {
    marginBottom: theme.spacing(1),
    padding: theme.spacing(2),
    backgroundColor: '#f8f9fa',
    borderRadius: 8,
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(6),
    minHeight: 200,
  },
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(3),
    color: '#212529',
    fontSize: '1.25rem',
    lineHeight: 1.3,
  },
  filterTextField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#ffffff',
      borderRadius: 8,
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#0E935F',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderWidth: 2,
      },
    },
    '& .MuiInputLabel-root': {
      fontWeight: 500,
    },
  },
  // Единый стиль для всех кнопок
  button: {
    ...ADMIN_COMPACT_BUTTON,
  },
  // Стиль для кнопок удаления (secondary)
  removeButton: {
    ...ADMIN_COMPACT_BUTTON,
    marginRight: theme.spacing(1),
  },
  // Стиль для outlined кнопок
  outlinedButton: {
    ...ADMIN_COMPACT_BUTTON,
    borderWidth: 1,
    '&:hover': {
      boxShadow: 'none',
      borderWidth: 1,
    },
  },
  compactButton: {
    ...ADMIN_COMPACT_BUTTON,
  },
  headerActions: {
    ...ADMIN_HEADER_ACTIONS,
    '& .MuiButton-root': {
      ...ADMIN_COMPACT_BUTTON,
    },
  },
  tabs: {
    '& .MuiTab-root': {
      textTransform: 'none',
      fontWeight: 500,
      fontSize: '0.8125rem',
      minHeight: 40,
      '&.Mui-selected': {
        fontWeight: 600,
      },
    },
    '& .MuiTabs-indicator': {
      height: 2,
      borderRadius: '2px 2px 0 0',
    },
  },
  card: {
    padding: theme.spacing(2.5),
    borderRadius: 10,
    backgroundColor: '#ffffff',
    border: '1px solid #e9ecef',
    transition: 'all 0.3s ease',
    '&:hover': {
      borderColor: '#0E935F',
      boxShadow: '0 4px 12px rgba(14, 147, 95, 0.1)',
    },
  },
  toolbar: {
    backgroundColor: '#f8f9fa',
    borderRadius: 8,
    padding: theme.spacing(1, 1.5),
    marginBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  toolbarActions: {
    ...ADMIN_HEADER_ACTIONS,
    marginLeft: 'auto',
    '& .MuiButton-root': {
      ...ADMIN_COMPACT_BUTTON,
    },
  },
});

